export default "__VITE_ASSET__6139571a__"